import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import StartTodayCom from "../StartTodayCom";
import SlideComp from "./Slide";
import { useSelector } from "react-redux";
import { blobURL, socialIcons } from "common/StringUtils";
import { LOCALES } from "common/constants";

const Footer = ({ dashboardFooter }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state?.auth);
  const language = localStorage.getItem("i18nextLng");

  const fakturaNuLogo = `${blobURL}/footer_logs.png`;
  const FooterLogo = `${blobURL}/footer_logs.png`;

  const footerColItems = [
    {
      title: "Contact",
      routes: [
        {
          isLink: true,
          name: "Invozio LV SIA",
          to:
            language === LOCALES.EN_US
              ? `/about-invozio?lang=${LOCALES.EN_US}`
              : `/om-invozio?lang=${LOCALES.SV_SE}`,
        },
        {
          isLink: true,
          name: `Org. ${t("Number")} : 502085–4062`,
          to:
            language === LOCALES.EN_US
              ? `/about-invozio?lang=${LOCALES.EN_US}`
              : `/om-invozio?lang=${LOCALES.SV_SE}`,
        },
        {
          isLink: false,
          name: `${t("VAT Number")}: SE502085406201`,
          to:
            language === LOCALES.EN_US
              ? `/about-invozio?lang=${LOCALES.EN_US}`
              : `/om-invozio?lang=${LOCALES.SV_SE}`,
        },
        {
          isLink: false,
          name: `${t("Account holder")} : Invozio LV SIA`,
          to:
            language === LOCALES.EN_US
              ? `/about-invozio?lang=${LOCALES.EN_US}`
              : `/om-invozio?lang=${LOCALES.SV_SE}`,
        },
        {
          isLink: false,
          name: "IBAN : LT13 3250 0895 5539 8439",
          to:
            language === LOCALES.EN_US
              ? `/about-invozio?lang=${LOCALES.EN_US}`
              : `/om-invozio?lang=${LOCALES.SV_SE}`,
        }, {
          isLink: false,
          name: "SWIFT/BIC : REVOLT21",
          to:
            language === LOCALES.EN_US
              ? `/about-invozio?lang=${LOCALES.EN_US}`
              : `/om-invozio?lang=${LOCALES.SV_SE}`,
        },
        //  {
        //   isLink: false,
        //   name: `${t("Clearing number")} : 1235`,
        //   to:
        //     language === LOCALES.EN_US
        //       ? `/about-invozio?lang=${LOCALES.EN_US}`
        //       : `/om-invozio?lang=${LOCALES.SV_SE}`,
        // }, {
        //   isLink: false,
        //   name: `${t("Account number")} : 0639339`,
        //   to:
        //     language === LOCALES.EN_US
        //       ? `/about-invozio?lang=${LOCALES.EN_US}`
        //       : `/om-invozio?lang=${LOCALES.SV_SE}`,
        // },
        // {
        //   isLink: false,
        //   name: `Swish- ${t("Number")} : 12 33 39 12 32`,
        //   to:
        //     language === LOCALES.EN_US
        //       ? `/about-invozio?lang=${LOCALES.EN_US}`
        //       : `/om-invozio?lang=${LOCALES.SV_SE}`,
        // },
        {
          isLink: false,
          name: "Bank : Revolut Bank",
          to:
            language === LOCALES.EN_US
              ? `/about-invozio?lang=${LOCALES.EN_US}`
              : `/om-invozio?lang=${LOCALES.SV_SE}`,
        },
        {
          isLink: false,
          name: `${t("For Swedish Bankgiro payments, use: 673–9007 handled by PS Finance Group.")}`,
          to:
            language === LOCALES.EN_US
              ? `/about-invozio?lang=${LOCALES.EN_US}`
              : `/om-invozio?lang=${LOCALES.SV_SE}`,
        },
      ],
    },

    {
      title: "Invozio",
      routes: [
        {
          isLink: true,
          name: "About us",
          to:
            language === LOCALES.EN_US
              ? `/about-invozio?lang=${LOCALES.EN_US}`
              : `/om-invozio?lang=${LOCALES.SV_SE}`,
        },
        {
          isLink: true,
          name: "This is how it works",
          to:
            language === LOCALES.EN_US
              ? `/how-works-invozio?lang=${LOCALES.EN_US}`
              : `/hur-fungerar-invozio?lang=${LOCALES.SV_SE}`,
        },

        {
          isLink: true,
          name: "Become an ambassador",
          to: `${
            user
              ? language === LOCALES.EN_US
                ? `/dashboard/ambassador?lang=${LOCALES.EN_US}`
                : `/instrumentbrada/ambassador?lang=${LOCALES.SV_SE}`
              : language === LOCALES.EN_US
              ? `/ambassador?lang=${LOCALES.EN_US}`
              : `/ambassador?lang=${LOCALES.SV_SE}`
          }`,
        },
        {
          isLink: true,
          name: "FAQ",
          to: `${
            user
              ? language === LOCALES.EN_US
                ? `/faq?lang=${LOCALES.EN_US}`
                : `/faq?lang=${LOCALES.SV_SE}`
              : language === LOCALES.EN_US
              ? `/faq?lang=${LOCALES.EN_US}`
              : `/faq?lang=${LOCALES.SV_SE}`
          }`,
        },
      ],
    },

    {
      title: "Terms",
      routes: [
        {
          isLink: true,
          name: "Privacy-policy & cookies",
          to: `${language === LOCALES.EN_US ? `/cookies?lang=${LOCALES.EN_US}` : `/cookies?lang=${LOCALES.SV_SE}`}`,
        },
      ],
    },

    {
      title: "Contact",
      routes: [
        {
          isLink: false,
          name: "Customer support",
          //   to: "/privacy-policy",
        },

        {
          isLink: true,
          name: `Phone: ${import.meta.env.VITE_SUPPORT_PHONE_NUMBER}`,
          to: `tel:${import.meta.env.VITE_SUPPORT_PHONE_NUMBER}`,
        },
        {
          isLink: true,
          name: "Email: support@invozio.com",
          to: "mailto:support@invozio.com",
        },
        {
          isLink: false,
          name: "For support inquiries related to finance, IT, and contractual matters, we will only respond via email within two working days.",
          to: "",
        },
        {
          isLink: false,
          name: `${t("Open weekdays 07-18.")} ${t(
            "Closed public holidays and the day before."
          )}`,
        },
      ],
    },
  ];

  return (
    <>
      <section
        className={
          dashboardFooter === false
            ? "footer_below"
            : "footer_below dashbrd_foter_below"
        }
      >
        <SlideComp />
      </section>
      <StartTodayCom dashboardFooter={dashboardFooter} />

      <footer
        className={
          dashboardFooter === false
            ? "home_Footer footer_hm"
            : "dashboard_footer footer_hm innerdashboard"
        }
      >
        <div className="container">
          <div className="row justify-content-between align-items-baseline">
            <div
              className={
                dashboardFooter === false
                  ? "col-md-5 col-lg-3 col-sm-6"
                  : "col-md-6 col-lg-3 col-sm-6"
              }
            >
              <div className="footer-box ftr_bx">
                <img
                  src={dashboardFooter === false ? fakturaNuLogo : FooterLogo}
                  alt="logo_image"
                  className="img-fluid"
                  loading="lazy"
                />
                <ul
                  className={dashboardFooter === false ? "list mt-4" : "mt-4"}
                >
                  {footerColItems[0].routes.map((route, index) => (
                    <li key={index}>
                      {route.isLink ? (
                        <Link
                          style={{ textDecoration: "underline" }}
                          className={
                            dashboardFooter === false ? "" : "dashboard_text"
                          }
                          to={route.to}
                          reloadDocument
                        >
                          {t(route.name)}
                        </Link>
                      ) : (
                        <span className="text-light">{t(route.name)}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div
              className={
                dashboardFooter === false
                  ? "col-md-2 col-lg-2 col-sm-6"
                  : "col-md-3 col-lg-2 col-sm-6"
              }
            >
              <div className="footer-box">
                <p
                  className={
                    dashboardFooter === false
                      ? "heading mb-0 footer_text"
                      : "dash_footer_head footer_text"
                  }
                >
                  {t(footerColItems[1].title)}
                </p>
                <ul className="mt-3">
                  {footerColItems[1].routes.map((route, index) => (
                    <li key={index}>
                      <Link
                        style={{ textDecoration: "underline" }}
                        className={
                          dashboardFooter === false ? "" : "dashboard_text"
                        }
                        to={route.to}
                        {...(route.name !== "Become an ambassador" ? { reloadDocument: true } : {})}
                      >
                        {t(route.name)}
                      </Link>
                    </li>
                  ))}
                  <li>
                    <a
                      style={{ textDecoration: "underline" }}
                      href="https://se.trustpilot.com/review/fakturanu.se?utm_medium=t"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {" "}
                      Trustpilot{" "}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div
              className={
                dashboardFooter === false
                  ? "col-md-2 col-lg-2 col-sm-6"
                  : "col-md-3 col-lg-2 col-sm-6"
              }
            >
              <div className="footer-box">
                <p
                  className={
                    dashboardFooter === false
                      ? "heading mb-0 footer_text"
                      : "dash_footer_head footer_text"
                  }
                >
                  {t(footerColItems[2].title)}
                </p>
                <ul className="mt-3">
                  {footerColItems[2].routes.map((route, index) => (
                    <li key={index}>
                      <Link
                        style={{ textDecoration: "underline" }}
                        className={
                          dashboardFooter === false ? "" : "dashboard_text"
                        }
                        to={route.to}
                        reloadDocument
                      >
                        {t(route.name)}
                      </Link>
                    </li>
                  ))}
                  {/* <li>
                        <Link
                          to="/Sitemap.xml"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {t("Sitemap")}
                        </Link>
                      </li> */}
                </ul>
              </div>
            </div>

            <div
              className={
                dashboardFooter === false
                  ? "col-md-4 col-sm-6"
                  : "col-md-5 col-lg-4 col-sm-6"
              }
            >
              <div className="footer-box">
                <p
                  className={
                    dashboardFooter === false
                      ? "heading mb-0 footer_text"
                      : "dash_footer_head footer_text"
                  }
                >
                  {t(footerColItems[3]?.title)}
                </p>
                <ul className="mt-3">
                  {footerColItems[3].routes.map((route, index) => (
                    <li key={index}>
                      {route.isLink ? (
                        <Link
                          style={{ textDecoration: "underline" }}
                          className={
                            dashboardFooter === false ? "" : "dashboard_text"
                          }
                          to={route.to}
                        >
                          {t(route.name)}
                        </Link>
                      ) : (
                        <span className="text-light">{t(route.name)}</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="social-icons nw_footer_desigm">
            <div className="div_nwe">
              <div className="para_gras">
                <span className="bordr_sets">{t("Official Channels")}</span>
              </div>
              <div className="icons">
                {socialIcons?.links.map((linkItem, index) => (
                  <a
                    className={
                      dashboardFooter === false
                        ? "social_media"
                        : "social_media"
                      // dashboard_footIcon
                    }
                    key={index}
                    href={linkItem.link}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={linkItem?.ariaLabel}
                  >
                    {linkItem.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
